import type {
  ProviderPtinActiveStatus,
  ProviderType,
} from '@/features/iam/providers/Provider'

/**
 * Gets the display title for a pro's type.
 *
 * @param proType
 */
export function getProviderTypeTitle(proType: ProviderType) {
  switch (proType) {
    case 'CPA':
      return 'CPA'
    case 'EA':
      return 'EA'
    case 'NotApplicable':
      return 'Unknown'
  }
}

/**
 * Gets the display text for a pro's PTIN status.
 *
 * @param activePtin
 */
export function getProviderPtinStatusText(
  activePtin: ProviderPtinActiveStatus,
) {
  switch (activePtin) {
    case 'Active':
      return 'Active'
    case 'Inactive':
    case 'NotApplicable':
      return 'Inactive'
  }
}
